export function isCanvasProduct(product) {
    return !!product.translated?.customFields?.frame_tags;
}

function getSelectedOptionForAttribute(product, attributeCode) {
	if (!isCanvasProduct(product)) {
		return false;
	}

	let foundProp = product.properties.filter(property => {
		return property.group?.customFields?.attributeCode === attributeCode;
	});

	if (!foundProp || foundProp.length === 0) {
		return false;
	}

	return foundProp[0].id;
}

export function getSelectedCanvasOptions(product) {
	return product.translated?.customFields?.frame_tags || [];
}
